import { useThemeColor } from "@themes/Colors";
import React from "react";
import { ICliente } from "./Cliente";
import { EnumEmpresa, IEmpresa } from "./Empresa";
import { EnumFaturaStatus } from "./FaturaStatus";
import { EnumFormaPagamento } from "./FormaPagamento";

export const faturaTipos = ["Contratual", "Avulsa", "Cancelamento", "Antecipada"] as const;
export type FaturaTipo = typeof faturaTipos[number];

export default interface IFatura {
    faturaId: number

    clienteId: number
    empresaId: EnumEmpresa
    faturaStatusId: EnumFaturaStatus
    formaPagamentoId: EnumFormaPagamento

    dataGeracao: Date
    dataVencimento: Date | null
    dataPagamento: Date

    valorPago: number
    valorDesconto: number
    saldo: number

    competenciaGeracao: string
    competenciaVencimento: string
    competenciaPagamento: string
    competenciaReferencia: string
    
    clienteNome: string
    clienteCpf: string
    clienteTelefone: string
    empresaNome: string
    valorTotal: number
    formaPagamentoNome: string
    faturaStatusNome: string

    dataHoraCancelamento: Date
    justificativaCancelamento: string

    baseCalculo: number
    valorOriginal: number,
    saldoJurosCalculado: number
    saldoMultaCalculado: number
    abonarJurosMulta: string
    abonarJurosMultaDesabilitado: boolean

    tipo: FaturaTipo

    cliente: ICliente
    empresa: IEmpresa
}

export function useFaturaTipoColor () {
    const themeColor = useThemeColor();

    const map : {[k in FaturaTipo]: string} = React.useMemo(() => ({
        "Contratual": themeColor.status.verde,
        "Avulsa": themeColor.status.azul,
        "Cancelamento": themeColor.status.vermelho,
        "Antecipada": themeColor.status.roxo,
    }), [themeColor.status.azul, themeColor.status.roxo, themeColor.status.verde, themeColor.status.vermelho]);

    return React.useMemo(() => map, [map]);
}